import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine'
import React from 'react'
import { Toaster } from 'react-hot-toast'
import { useMediaQuery } from '../hooks/useMediaQuery'
import style from './block.module.scss'

const ToasterBlock: React.FC = () => {
    const isMobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')')

    return (
        <BlockWrapper.Div>
            <Toaster position={isMobile ? 'top-center' : 'top-right'} />
        </BlockWrapper.Div>
    )
}

export default defineBlock({
    Block: ToasterBlock,
})
